// extracted by mini-css-extract-plugin
export default {"EditHealthCheckDialog":"EditHealthCheckDialog_EditHealthCheckDialog__Mdv7g"};